import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateManagedMeetingTemplate as CreateManagedMeetingTemplateMutation,
    CreateManagedMeetingTemplateVariables as CreateManagedMeetingTemplateMutationVariables,
    ManagedMeetingTemplateCreateInput,
} from 'nutshell-graphql-types';

import CREATE_MANAGED_MEETING_TEMPLATE from '../mutations/create-managed-meeting.graphql';

export function useCreateManagedMeetingTemplate(): {
    createManagedMeetingTemplate: (arg1: ManagedMeetingTemplateCreateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [createManagedMeetingTemplate, {loading, error}] = useMutation<
        CreateManagedMeetingTemplateMutation,
        CreateManagedMeetingTemplateMutationVariables
    >(CREATE_MANAGED_MEETING_TEMPLATE);

    return {
        createManagedMeetingTemplate: (input: ManagedMeetingTemplateCreateInput) =>
            createManagedMeetingTemplate({
                variables: {input},
            }).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.managedMeetingTemplateCreate &&
                    result.data.managedMeetingTemplateCreate.meeting &&
                    result.data.managedMeetingTemplateCreate.meeting.htmlUrlPath
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
